var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1113_447",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "#D9D9D9",
    stroke: "#D6B161"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1113_447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9875 12V16H7.97642L7.9875 16.0069V36V36.0125H8H40H40.0125V36V16V15.9774L39.9934 15.9894L24 25.9853L8.0125 15.9931V12.0226L23.9934 22.0106L23.9849 22.0242L24.0066 22.0106L40.0066 12.0106L40.0436 11.9875H40H8H7.9875V12ZM8 39.9875C6.90334 39.9875 5.96485 39.5972 5.18384 38.8162C4.40283 38.0352 4.0125 37.0967 4.0125 36V12C4.0125 10.9033 4.40283 9.96485 5.18384 9.18384C5.96485 8.40283 6.90334 8.0125 8 8.0125H40C41.0967 8.0125 42.0352 8.40283 42.8162 9.18384C43.5972 9.96485 43.9875 10.9033 43.9875 12V36C43.9875 37.0967 43.5972 38.0352 42.8162 38.8162C42.0352 39.5972 41.0967 39.9875 40 39.9875H8Z",
    fill: "#D6B161",
    stroke: "#D6B161",
    strokeWidth: 0.025
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.ded8b4aae71aef05373f16b4b2914f47.svg";
export { ForwardRef as ReactComponent };